import { render, staticRenderFns } from "./CreateVehicle.vue?vue&type=template&id=5e49804f&"
import script from "./CreateVehicle.vue?vue&type=script&lang=js&"
export * from "./CreateVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports